import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const ORDER_SOURCE_SCHEMA = order.orderService.versions.v1.schemas.ORDER_SOURCE_SCHEMA;

export type ORDER_SOURCE = z.infer<typeof ORDER_SOURCE_SCHEMA>;
